import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { cityRecordQuery } from "@/app/Cities/Cities/GraphQL/cityRecordQuery";

export function useCityRecord() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/cities/$id",
  });
  const { data } = useSuspenseGqlQuery(cityRecordQuery, {
    id: match.params.id,
  });

  return data.city;
}
